/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import config from 'my-phorest/config/environment';
import { variation } from 'ember-launch-darkly';
import { action } from '@ember/object';

export default class SupportDialogComponent extends Component {
  @service apollo;
  @service intl;
  @service notifications;
  @service reviewableTickets;
  @service router;
  @service session;

  get businessId() {
    return this.session.business.id;
  }

  get branchId() {
    return this.session.branch.id;
  }

  get hasReviewableTickets() {
    return this.reviewableTickets.reviewableTicketsCount > 0;
  }

  get embeddedPath() {
    return `businesses/${this.businessId}/branches/${this.branchId}/support-review`;
  }

  get currentUserName() {
    return this.session.user?.name || this.session.branch?.fullName;
  }

  get branchAccountId() {
    return this.session.branch.accountId;
  }

  get suggestionUrl() {
    const forums = {
      de: 'https://phorest.canny.io/deutsches-forum',
      fi: 'https://phorest.canny.io/finnish-forum',
    };

    return forums[this.intl.defaultLocale] || 'https://phorest.canny.io';
  }

  get widgetKey() {
    if (!variation('release-zendesk-sandbox-support')) {
      return config.zendesk.classicKey;
    }
    return config.zendesk.sandBoxKey;
  }

  @action
  loadZendeskWidget() {
    if (
      config.deployTarget &&
      config.deployTarget !== 'production' &&
      config.deployTarget !== 'cloudfront-prod'
    ) {
      return; // show only in production
    }

    window.zESettings = {
      webWidget: {
        color: { theme: '#115E59' },
        contactForm: {
          suppress: false,
          attachments: false,
          ticketForms: [{ id: config.zendesk.ticketFormId }],
          fields: [
            { id: 'name', prefill: { '*': this.currentUserName } },
            {
              id: 'email',
              prefill: {
                '*': this.args.currentUserEmail,
              },
            },
            { id: 360008170354, prefill: { '*': this.branchAccountId } },
          ],
        },
        helpCenter: { suppress: false },
      },
    };

    let script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${this.widgetKey}`;

    let timeoutId;

    const handleError = () => {
      clearTimeout(timeoutId);

      this.notifications.failure(
        this.intl.t('app-main-nav.support-dialog.contact-us-error.title'),
        this.intl.t('app-main-nav.support-dialog.contact-us-error.description'),
        {
          sticky: true,
        }
      );
    };

    timeoutId = setTimeout(() => {
      if (typeof window.zE !== 'function') {
        handleError();
      }
    }, 5000);

    script.onload = () => {
      const intervalId = setInterval(() => {
        if (typeof window.zE === 'function') {
          clearInterval(intervalId);
          window.zE(function () {
            window.zE.activate({ hideOnClose: true });

            window.zE('webWidget:on', 'close', function () {
              const iframe = document.getElementById('webWidget');

              if (iframe) {
                const iframeDocument =
                  iframe.contentDocument || iframe.contentWindow.document;
                const backButton = iframeDocument.querySelector(
                  'button[data-testid="Icon--back"]'
                );

                if (backButton) {
                  backButton.click();
                }
              }
            });
          });
        }
      }, 100);
    };

    script.onerror = handleError;

    document.body.appendChild(script);
  }
}
